/**
 * Tags store their icon either as a bare Font Awesome name (`fa-soup`, the
 * convention on prod) or already prefixed (`fas fa-soup`, seeded tenants).
 * Returns a class usable in v-icon for both, '' when the tag has no icon.
 */
export function tagIconClass (iconClass: string | null | undefined): string {
  const value = (iconClass || '').trim()

  if (!value) {
    return ''
  }

  return /^(fas|far|fal|fab|fad)\s/.test(value) ? value : `fas ${value}`
}
